import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import dynamic from 'next/dynamic'

import {t, axios} from '@lib/helpers'

const ImageLoader = dynamic(() => import('@components/ImageLoader'))
const Meta = dynamic(() => import('@components/Meta'))
const ProductItem = dynamic(() => import('@components/ProductItem'))
const Custom404 = dynamic(() => import('@components/Custom404'))

const ProductsShow = ({product}) => {
  if (get(product, '_status')) {
    return <Custom404 />
  }

  return (
    <React.Fragment>
      <Meta
        title={
          get(product, 'meta_title') ||
          `${t('pages.products.title')} – ${get(product, 'title')} – ${t(
            'layout.title'
          )}`
        }
        description={
          get(product, 'meta_description') || get(product, 'description')
        }
      />

      <div className='ProductsShow'>
        <div className='BodySpace'>
          <div className='ProductsShow__hero'>
            <div className='container'>
              <div className='ProductsShow__hero__wrapper'>
                <div className='ProductsShow__hero__left'>
                  <h1 className='ProductsShow__hero__h2'>
                    {get(product, 'title')}
                  </h1>

                  <p className='ProductsShow__hero__p'>
                    {get(product, 'description')}
                  </p>
                </div>

                <div className='ProductsShow__hero__image'>
                  <svg
                    className='ProductsShow__hero__image__svg'
                    viewBox='0 0 490 580'
                  />

                  <div className='ProductsShow__hero__image__wrapper'>
                    <div className='Products__dl__item__image__wrapper'>
                      <ImageLoader
                        klass='ProductsShow__hero__image__img'
                        src={get(product, 'image_1.url')}
                        srcSet={`${get(product, 'image_2.url')} 2x`}
                        external
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {get(product, 'content') && (
            <div className='ProductsShow__content'>
              <div className='container'>
                <h3 className='ProductsShow__content__h3'>
                  {t('pages.productsShow.story', {
                    title: get(product, 'title'),
                  })}
                </h3>

                <div
                  className='Markdown'
                  dangerouslySetInnerHTML={{__html: get(product, 'content')}}
                ></div>
              </div>
            </div>
          )}

          {get(product, 'url') && (
            <div className='ProductsShow__more'>
              <div className='container'>
                <h4 className='ProductsShow__more__h4'>
                  {t('pages.productsShow.more', {
                    title: get(product, 'title'),
                  })}
                </h4>

                <p className='ProductsShow__more__p'>
                  {t('pages.productsShow.p')}
                </p>

                <a
                  className='Button'
                  href={get(product, 'url')}
                  target='_blank'
                  rel='nofollow noopener noreferrer'
                >
                  {t('pages.productsShow.visit')}
                </a>
              </div>
            </div>
          )}

          <div className='ProductsShow__recommend'>
            <div className='container'>
              <h3 className='ProductsShow__recommend__h3'>
                {t('pages.productsShow.recommend.h3')}
              </h3>

              <dl className='ProductsShow__recommend__dl'>
                {(get(product, 'recommended') || []).map((x, i) => (
                  <ProductItem key={i} x={x} />
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

ProductsShow.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let product

  try {
    product = await axios.get(`/products/${get(ctx, 'query.id')}`)
  } catch (e) {
    const _status = get(e, 'response.status')

    if (ctx.res) {
      ctx.res.statusCode = _status
    }

    return {
      props: {
        product: {
          _status,
        },
      },
    }
  }

  return {
    props: {
      product: get(product, 'data.data'),
      query: get(ctx, 'query'),
    },
  }
}

export default ProductsShow
